import { adminClient as apolloClient } from '@/store/apollo';

import GenerateTextMutation from '@/store/graphql/artificial-intelligence/mutations/GenerateText.gql';
import TextModelsQuery from '@/store/graphql/artificial-intelligence/queries/TextModels.gql';

// AI text generation (ai-content). `formats` are the EX_AI_TextFormat values the
// target can display; the answer is HTML reduced to exactly those. `context` is
// an EX_AI_TextContextInput: the record the editor belongs to and the field itself.
export default {
    generateText: (cmsId, prompt, formats, context) =>
        apolloClient.mutate({
            mutation: GenerateTextMutation,
            variables: { cms_id: parseInt(cmsId, 10), prompt, formats, context },
        }).then(({ data }) => data.EX_AI_GenerateText),
    // The language models a tenant can choose for `feature` ('chatbot', 'ai-content'), with their prices for the CMS.
    fetchTextModels: (cmsId, feature) =>
        apolloClient.query({
            query: TextModelsQuery,
            variables: { cms_id: parseInt(cmsId, 10), feature },
            fetchPolicy: 'no-cache',
        }).then(({ data }) => data.EX_AI_TextModels),
};
